function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Select, Drawer, Form, Modal, notification, DatePicker, Space, Input } from 'antd';
import { Table } from 'react-bootstrap';
import { PencilSquare, HourglassSplit, CheckCircleFill, XCircleFill, EyeFill, Eyedropper, CardList } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import SaveMedicalQuestions from "../components/forms/SaveMedicalQuestions";
import SaveLaboData from "../components/forms/SaveLaboData";
import LaboratorySheet from "../components/LaboratorySheet";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { useNavigate } from "react-router-dom";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
  Link = Typography.Link;
var TabPane = Tabs.TabPane;
var confirm = Modal.confirm;
var Laboratoire = function Laboratoire() {
  var navigate = useNavigate();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    compList = _useState4[0],
    setCompList = _useState4[1];
  var _useState5 = useState([{
      value: 0,
      label: "TOUTES"
    }]),
    _useState6 = _slicedToArray(_useState5, 2),
    compOptions = _useState6[0],
    setCompOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    companyId = _useState8[0],
    setCompanyId = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    company = _useState0[0],
    setCompany = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    pendingCustomers = _useState10[0],
    setPendingCustomers = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    doneCustomers = _useState12[0],
    setDoneCustomers = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    validatedCustomers = _useState14[0],
    setValidatedCustomers = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    currentCustomer = _useState16[0],
    setCurrentCustomer = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    dataChanged = _useState18[0],
    setDataChanged = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showEditData = _useState20[0],
    setShowEditData = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showDisplayData = _useState22[0],
    setShowDisplayData = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showSample = _useState24[0],
    setShowSample = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isSampleLoading = _useState26[0],
    setIsSampleLoading = _useState26[1];
  var _useState27 = useState(20),
    _useState28 = _slicedToArray(_useState27, 2),
    limit = _useState28[0],
    setLimit = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    offset = _useState30[0],
    setOffset = _useState30[1];
  var _useState31 = useState("0"),
    _useState32 = _slicedToArray(_useState31, 2),
    keyword = _useState32[0],
    setKeyword = _useState32[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var ref = useRef();
  var tabl = useRef();
  var handleCompanyChange = function handleCompanyChange(v) {
    if (compList.filter(function (c) {
      return c.id == v;
    }).length > 0) {
      setCompany(compList.filter(function (c) {
        return c.id == v;
      })[0]);
      setCompanyId(compList.filter(function (c) {
        return c.id == v;
      })[0].id);
      localStorage.setItem("defaultCompany", compList.filter(function (c) {
        return c.id == v;
      })[0].id);
    } else {
      setCompany(null);
      setCompanyId(0);
      localStorage.setItem("defaultCompany", 0);
    }
  };
  var handleValidateResult = function handleValidateResult(c) {
    setCurrentCustomer(c);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La validation du resultat de laboratoire pour le candidat ", c.candidate_code, " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "validateresultset", {
          customer_id: c.id.toString(),
          laboratory_result_id: c.laboratory_result_id
        }).then(function (response) {
          if (response.data.status == 500) {
            return navigate('/');
          }
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur",
            description: "Une erreur est survenue " + error.toString()
          });
        });
      }
    });
  };
  var handleInvalidateResult = function handleInvalidateResult(c) {
    setCurrentCustomer(c);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'invalidation du resultat de laboratoire pour le candidat ", c.candidate_code, " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "invalidateresultset", {
          customer_id: c.id,
          laboratory_result_id: c.laboratory_result_id
        }).then(function (response) {
          if (response.data.status == 500) {
            return navigate('/');
          }
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur",
            description: "Une erreur est survenue " + error.toString()
          });
        });
      }
    });
  };
  var handleKewordChange = function handleKewordChange(v) {
    setKeyword(v.target.value);
  };
  var handleMore = function handleMore() {
    setLimit(function (prev) {
      return prev + 20;
    });
  };
  var handleSample = function handleSample(c) {
    setCurrentCustomer(c);
    setShowSample(true);
    var sc;
    axios.get("".concat(Common.baseApiUrl, "getnextlabosample/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        sc = response.data.sampleid;
        confirm({
          title: /*#__PURE__*/_jsx("b", {
            children: "ECHANTILLONNAGE"
          }),
          content: /*#__PURE__*/_jsx("div", {
            children: isSampleLoading ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsxs("div", {
              children: ["Valider l'\xE9chantillon ", /*#__PURE__*/_jsxs("b", {
                style: {
                  fontSize: "24px"
                },
                children: [" N\xBA ", response.data.sampleid]
              }), " pour le candidat ", c.name, " ?"]
            })
          }),
          onOk: function onOk() {
            axios.post(Common.baseApiUrl + "makelabosample", {
              customer_id: c.id.toString(),
              user_id: Common.currentUser.id,
              sample_code: sc
            }).then(function (response) {
              if (response.data.status == 200) {
                notification.success({
                  message: "Ok!",
                  description: response.data.message
                });
                setDataChanged(true);
              } else {
                notification.error({
                  message: "Echec",
                  description: response.data.message
                });
              }
            })["catch"](function (error) {
              notification.error({
                message: "Echec",
                description: "Une erreur est survenue"
              });
            })["finally"](function () {
              setDataChanged(true);
            });
          }
        });
      } else {
        notification.error({
          message: "Echec",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Echec",
        description: "Une erreur est survenue"
      });
    })["finally"](function () {
      setIsSampleLoading(false);
    });
  };
  var items = [{
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(Eyedropper, {
        size: 24
      })
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        ref: tabl,
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: pendingCustomers.map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Button, {
                  type: "link",
                  loading: isSampleLoading,
                  onClick: function onClick() {
                    handleSample(c);
                  },
                  children: [/*#__PURE__*/_jsx(Eyedropper, {
                    size: 22
                  }), " ", /*#__PURE__*/_jsx("b", {
                    children: " PRELEVER"
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(CardList, {
        size: 24
      })
    }),
    key: 3,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: doneCustomers.map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowEditData(true);
                    },
                    children: [/*#__PURE__*/_jsx(PencilSquare, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " MODIFIER"
                    })]
                  }), /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: [/*#__PURE__*/_jsx(EyeFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " VOIR"
                    })]
                  }), /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      handleValidateResult(c);
                    },
                    children: [/*#__PURE__*/_jsx(CheckCircleFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " VALIDER"
                    })]
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(CheckCircleFill, {
        size: 24
      })
    }),
    key: 4,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: validatedCustomers.map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowEditData(true);
                    },
                    children: [/*#__PURE__*/_jsx(PencilSquare, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " MODIFIER"
                    })]
                  }), /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: [/*#__PURE__*/_jsx(EyeFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " VOIR"
                    })]
                  }), /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    style: {
                      color: '#E77E71'
                    },
                    onClick: function onClick() {
                      handleInvalidateResult(c);
                    },
                    children: [/*#__PURE__*/_jsx(XCircleFill, {
                      color: "#E77E71",
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " INVALIDER"
                    })]
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }];
  var loadData = function loadData(cid) {
    setIsDataLoading(true);
    if (cid == null) return;
    axios.post("".concat(Common.baseApiUrl, "getlaboqueue"), {
      company_id: cid,
      user_id: Common.currentUser.id,
      limit: limit,
      offset: offset,
      keyword: keyword
    }).then(function (response) {
      if (response.data.status == 200) {
        setPendingCustomers([]);
        setDoneCustomers([]);
        setValidatedCustomers([]);
        response.data.customers.forEach(function (c) {
          if (c.laboratory_result_id == null) setPendingCustomers(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          if (c.laboratory_result != null && c.laboratory_result.status == 0) setDoneCustomers(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          if (c.laboratory_result != null && c.laboratory_result.status == 1) setValidatedCustomers(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
        });
      } else {
        notification.error({
          message: "Erreur"
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([{
          value: 0,
          label: "Toutes"
        }]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        setCompList(response.data.companyList);
        //setCompanyId(response.data.companyList[0].id);     
        setCompanyId(0);
        //setCompany(response.data.companyList[0]);
        setCompany(null);
        //loadData(response.data.companyList[0].id);      
        if (response.data.companyList.length > 0) {
          if (localStorage.getItem("defaultCompany") != null && localStorage.getItem("defaultCompany") != 'undefined') {
            form.setFieldsValue({
              comp: parseInt(localStorage.getItem("defaultCompany"))
            });
          } else {
            form.setFieldsValue({
              comp: response.data.companyList[0].id
            });
            localStorage.setItem("defaultCompany", response.data.companyList[0].id);
          }
        }
        loadData(localStorage.getItem("defaultCompany"));
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    setDataChanged(false);
    loadData(companyId);
  }, [companyId, dataChanged, company, keyword, limit, offset]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "#DONNEE LABORATOIR_BIOCHIMIQUE"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "comp",
                children: /*#__PURE__*/_jsx(Select, {
                  showSearch: true,
                  optionLabelProp: "label",
                  optionFilterProp: "label",
                  filterOption: function filterOption(input, option) {
                    return option.label.toLowerCase().includes(input.toLowerCase());
                  },
                  options: compOptions,
                  onChange: handleCompanyChange,
                  style: {
                    width: "200px"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Input, {
                  onChange: handleKewordChange,
                  placeholder: "Code dossier"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Tabs, {
            items: items,
            animated: true,
            tabPlacement: "start",
            defaultActiveKey: 1
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx(Button, {
              loading: isDataLoading,
              type: "default",
              onClick: handleMore,
              children: /*#__PURE__*/_jsx("b", {
                children: "VOIR PLUS"
              })
            })
          })]
        })
      })]
    }), currentCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        open: showEditData,
        title: /*#__PURE__*/_jsx("b", {
          children: "ENTREZ LES DONNEES DU LABO"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowEditData(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(SaveLaboData, {
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showDisplayData,
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS QUESTIONNAIRE"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowDisplayData(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref) {
              var handlePrint = _ref.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(LaboratorySheet, {
          ref: ref,
          candidat: currentCustomer
        })
      })]
    })]
  });
};
export default Laboratoire;